// Text about events (port of web/format.js; the shared parts are RULES, shared/cases/*). Pure functions: callers
// pass the clock and your location.
import { T } from "../shared/config";
import { RULES, type LatLng } from "../shared/rules";
import type { FeedEvent } from "./event";

/** "0.3 mi", "450 ft"; null without your location. */
export function distance(e: FeedEvent, from: LatLng | null) {
  if (!from) return null;
  const meters = RULES.metersBetween(from, e), miles = meters / 1609.344;
  if (miles < 0.1) return `${Math.round((meters * 3.28084) / 10) * 10} ft`;
  return miles < 10 ? `${miles.toFixed(1)} mi` : `${Math.round(miles)} mi`;
}

/** "Sat Oct 31 · 8pm – 11pm"; an inferred end reads "– ~10:30pm"; an unknown end, just the start. */
export function schedule(e: FeedEvent) {
  const day = RULES.dayMonth(e.start), t = RULES.timeString;
  if (!e.end) return `${day} · ${t(e.start)}`;
  const sameDay = e.end.toDateString() === e.start.toDateString(), about = e.end_inferred ? "~" : "";
  if (sameDay || +e.end - +e.start < 12 * 3600e3) return `${day} · ${t(e.start)} – ${about}${t(e.end)}`;
  return `${day} ${t(e.start)} – ${about}${RULES.dayMonth(e.end)} ${t(e.end)}`;
}

function hostOf(url?: string | null) {
  try { return url ? new URL(url).host.replace(/^www\./, "") : null; } catch { return null; }
}
/** "From Low Tide Kava on Instagram", "From St Pete Catalyst", "From parkrun.us"; null for user events. */
export function sourceLine(e: FeedEvent) {
  if (e.source === "user" || e.source === "sample") return null;
  if (e.source === "instagram") return e.source_name ? `From ${e.source_name} on Instagram` : "From Instagram";
  if (e.source_name) return `From ${e.source_name}`;
  const host = hostOf(e.source_url);
  return host ? `From ${host}` : e.source === "recurring" || !e.source ? null : `From ${e.source}`;
}
export const sourceNote = (e: FeedEvent) => (e.source === "user" ? T("card.userEvent") : null);

/** An image URL from the server (/media/...) made absolute. */
export const imageUrl = (e: FeedEvent) => (e.image_url ? new URL(e.image_url, location.origin).href : null);
